// extracted by mini-css-extract-plugin
module.exports = {"passed":"ChallengeDetails-module__passed___2FGfi"};